import React, {useContext} from 'react';

import {WidthItem} from 'src/components/width-item';
import {MAX_NUMBER_VALUE} from 'src/constants';
import {useLicenseCommonLimits} from 'src/hooks/dictionaries';

import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';


import type {LocaleContextType} from '@pb/kit-context-locale';
import type {Limit} from 'src/openapi/admin/models/Limit';

type Props = {
    description: React.ReactNode,
    defaultUsageLimits: Array<Limit> | null,
};

export const DefaultLimitsPopoverContent = (props: Props) => {
    const {licenseCommonLimits} = useLicenseCommonLimits();
    const {locale} = useContext<LocaleContextType>(LocaleContext);

    return (
        <Group direction="v" gap="m">
            <b>The {props.description} license defaults</b>
            {licenseCommonLimits.map(({description, children}) => {
                return (
                    <Group key={description} direction="v" gap="xxs">
                        <b>{description}</b>
                        {children?.map(({description: limitDescription, code}) => {
                            const value = props.defaultUsageLimits?.find(
                                e => e.limitId === code,
                            )?.value || 0;

                            return (
                                <Group key={code} gap="none">
                                    <WidthItem width={93}>{limitDescription}:</WidthItem>
                                    {value !== MAX_NUMBER_VALUE ? Integer.format(value, locale) : 'Unlimited'}
                                </Group>
                            );
                        })}
                    </Group>
                );
            })}
        </Group>
    );
};
